import { Metric } from "../../dashboards/shared/dashboard-config/dashboard-config.model";
import { METRIC_PROFILES } from "../../dashboards/shared/dashboard-config/metrics/metric-profile-implementations";

/**
 * Product providing the bottom-up analyses (Gesamtwirtschaft).
 * All remaining products are top-down analyses.
 */
export const BOTTOM_UP_PRODUCT_ID = 8;

export enum AnalysisMode {
  BottomUp = 'bottom-up',
  TopDown = 'top-down'
}

export const DEFAULT_ANALYSIS_MODE = AnalysisMode.TopDown

export interface MetricOption {
  id: Metric;
  label: string;
  visible: boolean;
}

export const DEFAULT_METRIC_ID = Metric.CompaniesCount;

export function getMetricOptions(analysisMode: AnalysisMode, productId?: number) {
  const option = (id: Metric, visible: boolean) => ({ id, label: METRIC_PROFILES[id].labels.label, visible });
  return [
    option(Metric.CompaniesCount, true),
    option(Metric.CompaniesRevenue, true),
    option(Metric.GrossValueAdded, true),
    option(Metric.EconomicParticipant, true),
    option(Metric.Employed, true),
    option(Metric.SelfEmployed, analysisMode !== AnalysisMode.BottomUp && productId === 1),
  ]
}

